CheckoutV2.Log = function(checkout) {
	var log = this;
	
	this.enabled = 0;
	
	this.init = function() {
		log.enabled = checkout.config.debug || 0;
	};
	
	this.debug = function(strMsg, inVar, optClass) {
		if (log.enabled) {
			var str = (optClass ? optClass + ': ' : '') + (strMsg || '');
			if (str && inVar) {
				console.log(str, inVar);
			} else {
				console.log(str);
			}
		}
	};

	this.init();

};